<template>
	<div class="blog">
		<fluke-card>
			<header>
				<div class="title">
					Categorias
				</div>
				<div class="description">
					Lista de todos as categorias
				</div>
			</header>
			<main>
				<v-data-table
					:headers="headers"
					:items="categories"
					:rows-per-page-items="[5,10,50]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables">

					<template v-slot:items="props">
						<td v-on:click="edit(props.item.id)">{{ props.item.category }}</td>
					</template>
				</v-data-table>
			</main>
			<footer v-if="permission.write">
				<fluke-button v-on:click.native="add">Adicionar Nova Categoria</fluke-button>
			</footer>
		</fluke-card>
	</div>
</template>

<script>
import axios from 'axios'
import Card from '../../../components/Main/Content/Card/Card.vue';
import SideCard from '../../../components/Main/Content/SideCard/SideCard.vue';
import Button from '../../../components/Main/Content/Button/Button.vue';

import permission from '../../../mixins/permissions';

export default {
	mixins: [ permission ],
	data () {
		return {
			categories: [],
			headers: [
				{
					text: "Título",
					align: 'left',
					value: 'category'
				},
			],
			permission: {
				read: false,
				write: false
			}
		}
	},
	components: {
		'fluke-card': Card,
		'fluke-side-card': SideCard,
		'fluke-button': Button
	},
	created () {
		this.getPosts();
		this.permission = this.getUserPagePermission('blog');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
	},
	methods: {
		async getPosts () {
			const result = await axios.get( this.$myServerAddresses.blog + 'categories', {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            });
			this.categories = result.data;
		},
		async publish () {
			const result = await axios.post(
				this.$myServerAddresses.blog + 'categories',
				{
					title: this.title
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
			)

		},
		add: function() {
			this.$router.push({ name: 'blog-categories-add' });
		},
		edit: function( index ) {
			this.$router.push({ name: 'blog-categories-edit', params: { id: index } });
		}
	}
}
</script>


